import React, { useEffect, useState } from "react";
import GroupOrder from "../../assets/GroupOrder.png";
import calender from "../../assets/calender.png";
import profile from "../../assets/profile.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import statusIcon from "../../assets/orders/status.png";
import check from "../../assets/orders/check.png";
import stepsCompleted from "../../assets/orders/stepsCompleted.png";
import { Link } from "react-router-dom";
import { CheckCircleFilled, DownOutlined, UpOutlined } from "@ant-design/icons";
import { Carousel, Collapse, Input, message, Modal, Rate } from "antd";
import { fetchOrderById } from "../../redux/ShowOrderIdSlice";
import { useDispatch, useSelector } from "react-redux";
import { submitFeedback } from "../../redux/rateOrderSlice";
import ReactStars from "react-stars";
import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const Completed = ({ idOrder }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalView, setIsModalView] = useState(false);

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const [collapsed, setCollapsed] = useState(false);
  let [open, setOpen] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    {
      collapsed ? <DownOutlined /> : <UpOutlined />;
    }
  };
  const customExpandIcon = ({ isActive }) =>
    isActive ? (
      <UpOutlined className="plus-icon mt-4" />
    ) : (
      <DownOutlined className="plus-icon mt-4" />
    );

  const dispatch = useDispatch();
  const { order, status, error } = useSelector((state) => state.order);

  useEffect(() => {
    dispatch(fetchOrderById(idOrder));
  }, [dispatch]);

  const feedbackStatus = useSelector((state) => state.status);
  // const feedbackError = useSelector((state) => state.error);

  const [rate, setRate] = useState(0);
  const handleRatingChange = (newRating) => {
    setRate(newRating);
  };
  const [rateComment, setRateComment] = useState("");

  const items = [
    {
      key: "1",
      label: "Order Details",
      children: (
        <div>
          <img src={stepsCompleted} className="w-[300px] mx-auto my-4" />
          <div className="bg-[#FCFBFA] rounded-2xl font-medium w-[300px] p-5 mx-auto text-lg">
            <h3 className="text-[#525D71] text-xl">Confirmed Pricing</h3>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-[#A4ADBC] mt-3">Price</p>
                <p className="text-[#FE9B71]">{order?.clear_price} SAR</p>
              </div>
              <div>
                <p className="text-[#A4ADBC] mt-3">Wallet</p>
                <p className="text-[#FE9B71]">{order?.wallet_pay} SAR</p>
              </div>
            </div>
          </div>

          <div className="mx-auto text-center my-5">
            <img src={check} className="w-[40px] mx-auto mb-2" />
            <p className="text-[#283D63] font-semibold">
              Cash payment successfully taken
            </p>
          </div>

          <div className="px-5">
            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img src={calender} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">
                  {order?.date} | {order?.time}
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img src={address} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">{order?.address}</p>
              </div>
            </div>

            <div className="flex items-start mt-5 ">
              <img src={desc} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
              <p className="text-[#283D63] font-medium">{order?.description}</p>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img
                  src={upload}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                {order?.uploaded_images?.length > 0 ? (
                  <>
                    <button
                      onClick={showModalView}
                      className="text-[#6682B6] underline font-medium"
                    >
                      {t("View Uploaded Images")}
                    </button>
                    <Modal
                      title={t("Uploaded Images")}
                      className="orderModal orderModalPricing w_small_modal"
                      open={isModalView}
                      onOk={handleOkView}
                      onCancel={handleCancelView}
                      footer={null}
                    >
                      <Carousel
                        arrows
                        infinite={false}
                        className="custome_carousel_images"
                      >
                        {order?.uploaded_images?.map((img, index) => (
                          <div key={index}>
                            <img
                              src={`https://service.samoolah.com/${img}`}
                              alt={`Uploaded image ${index + 1}`}
                              className="w-[120px] mx-auto my-5"
                            />
                          </div>
                        ))}
                      </Carousel>
                    </Modal>
                  </>
                ) : (
                  <p className="text-[#283D63] font-medium">
                    {t("No Uploaded Images")}
                  </p>
                )}
              </div>
              <div className="flex items-center mt-3 ">
                <img src={statusIcon} className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91] font-medium">{t("Status")}</p>
                <p className="text-[#283D63] font-medium ml-2">Completed</p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  // const showModal = async () => {
  //   if (!rate) {
  //     message.error("Please provide a rating.");
  //     return;
  //   }

  //   const feedbackData = {
  //     order_id: idOrder,
  //     rate,
  //     rate_comment: rateComment,
  //   };

  //   try {
  //     await axios.post("/api/feedback", feedbackData);
  //     setIsModalOpen(true);
  //   } catch (error) {
  //     console.error("Error submitting feedback:", error);
  //     message.error("Failed to submit feedback. Please try again.");
  //   }
  // };

  const handleSubmit = async () => {
    if (!rate) {
      message.error("Please provide a rating.");
      return;
    }

    const feedbackData = {
      order_id: idOrder,
      rate,
      rate_comment: rateComment,
    };

    try {
      await dispatch(submitFeedback(feedbackData))
        .unwrap()
        .then(() => {
          setIsModalOpen(false);
          message.success("Thank you for your feedback!");
        });
    } catch (error) {
      console.error("Error submitting feedback:", error);
      message.error("Failed to submit feedback. Please try again.");
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div className="mx-auto text-center">
        <img src={check} className="w-[50px] mx-auto my-5" />
        <p className="text-[#525D71] font-semibold">Order Complete</p>
      </div>
      <div className="my-5 mx-auto">
        <img
          src={`https://service.samoolah.com/${order?.category?.icon}`}
          className="w-[120px] mx-auto bg-[#FCFBFA] rounded-2xl p-3"
        />
      </div>

      <div className="text-center">
        <p className="text-[#737E91] font-semibold text-xl">
          Order number:{" "}
          <span className="text-[#283D63] font-semibold">#{order?.id}</span>
        </p>
        <p className="text-[#A6ADB9] mt-2">
          Order created on {order?.date} <br /> {order?.time}
        </p>
      </div>

      <button className="text-[#FE9B71] rounded-full text-lg font-semibold border-2 border-[#FE9B71] px-10 py-2 mt-5 mb-5 flex mx-auto">
        View Receipt
      </button>

      <div className="bg-[#FCFBFA] rounded-2xl my-5 px-7 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {order?.agent?.image == null ? (
              <img src={profile} className="w-[48px] mr-3" />
            ) : (
              <img
                src={`https://service.samoolah.com${order?.agent?.image}`}
                className="w-[48px] mr-3 rounded-full"
                onError={(e) => (e.target.src = profile)}
              />
            )}
            <p className="text-[#525D71] font-medium text-lg">
              {order?.agent?.name} {order?.agent?.last_name} handled your
              service request
            </p>
          </div>
        </div>
      </div>

      <Collapse
        defaultActiveKey={["1"]}
        inlineCollapsed={collapsed}
        items={items}
        expandIcon={customExpandIcon}
        expandIconPosition="right"
        bordered={false}
        className="bg-white custom_collapse"
      />

      <div className="mt-3">
        {order?.rate === null ? (
          <>
            <h3 className="text-[#14294F] text-xl font-semibold">
              Rate Service Provided
            </h3>
            <p className="text-[#42567B] mt-4 text-center font-semibold">
              How satisfied are you with the service provided?
            </p>
            <>
              <ReactStars
                count={5}
                onChange={handleRatingChange}
                value={rate}
                size={30}
                color1={"#dcdcdc"}
                color2={"#ffd700"}
                half={true}
                className="mx-auto flex justify-center mt-0 relative z-10"
              />

              <p className="text-[#42567B] mt-1 text-center">
                Do you have any reviews or suggestions that you’d like to share?
              </p>

              <div className="lg:mx-10">
                <TextArea
                  placeholder="Type in here your review / suggestions ……"
                  allowClear
                  onChange={(e) => setRateComment(e.target.value)}
                  className="w-full my-4 border-0 h-[100px] rounded-3xl"
                />
              </div>

              <div>
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={feedbackStatus === "loading"}
                  className={`bg-[#FE9B71] text-white rounded-full px-14 py-3 text-lg mx-auto flex ${
                    feedbackStatus === "loading" &&
                    "opacity-50 cursor-not-allowed"
                  }`}
                >
                  {feedbackStatus === "loading" ? "Submitting..." : "Submit"}
                </button>
                <Modal
                  title=""
                  className="orderModal orderModalPricing w_small_modal"
                  open={isModalOpen}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  footer={null}
                >
                  <div className="mt-6">
                    <p className="text-[#14294F] text-center font-bold text-xl">
                      Your feed back has been submitted <br /> Successfully
                    </p>
                    <p className="text-[#A6ADB9] text-center text-lg my-4">
                      Thanks for giving the time to rate our services.
                    </p>
                    <button
                      onClick={handleCancel}
                      className="bg-[#FE9B71] text-white rounded-full px-10 py-2 text-lg mx-auto flex my-4 mt-8"
                    >
                      Continue
                    </button>
                  </div>
                </Modal>
              </div>
            </>
          </>
        ) : (
          <>
            <h3 className="text-[#14294F] text-xl font-semibold">My Rate</h3>
            <p className="text-[#42567B] mt-4 text-center font-semibold">
              You gave a total of:
            </p>
            <Rate disabled defaultValue={order?.rate} />
            <p className="bg-[#F9FBFC] text-[#A3B9DD] p-4 rounded-3xl">
              {order?.rate_comment}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Completed;
